<template>
	<div class="">
		<div class="logo"><img src="../../static/images/logo.png" alt="" /></div>
		<div class="des">福建省民族管弦乐学会欢迎你</div>
		
		<router-link :to="{name:'loginPhone'}" >
		<div class="login flex flex-align-center flex-jus-center" >
			<img src="../../static/images/weixinLogo.png" class="weixinLogo" />
			<span>微信授权</span>
		</div>
		</router-link>
	</div>
</template>

<script>
/* eslint-disable */
export default {
	watch: {},
	data() {
		return {};
	},
	created() {},
	mounted() {},
	methods: {
		login() {
			// window.location.href =
			// 	'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
			// 	'wxd6380601a2e3910f' +
			// 	'&redirect_uri=' +
			// 	encodeURIComponent(window.location.href) +
			// 	'&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect';

			// this.$get('wechat/login', {
			// 	callback_url: encodeURIComponent(window.location.href)
			// }).then(res => {
			// 	console.log(res,"wechat/login");
			// })
			// this.$router.push({name: 'loginPhone'})
		}
	}
};
</script>

<style scoped lang="stylus">
.logo
	width 160px
	height 160px
	margin 192px auto 0 auto
	img
		width 100%
		height 100%
.des
	margin 0 auto
	margin-top 56px
	width 80%
	text-align center
	font-size 40px
	font-weight bold
	color #000000
.login
	margin 346px auto 0 auto
	width 566px
	height 84px
	line-height 84px
	text-align center
	background #4CBF00
	border-radius 46px
	font-size 32px
	color #FFFFFF
	.weixinLogo
		width 44px
		height 36px
		margin-right 8px
</style>
